import { ReactNode, useMemo } from 'react';

import { Divider, CardActions, Box, LoadingOverlay } from '@occc-app/design-system';

type FormLayoutProps = {
  actions: ReactNode;
  children?: ReactNode;
  isLoading?: boolean;
  type?: 'default' | 'primary';
};

export const FormLayout = ({ actions, children, isLoading, type = 'default' }: FormLayoutProps) => {
  const actionStyle = useMemo(() => {
    const disabledStyle = isLoading ? { pointerEvents: 'none' } : {};
    if (type === 'default') return disabledStyle;

    return {
      ...disabledStyle,
      justifyContent: 'end',
      gap: 1,
      px: 0,
    };
  }, [type, isLoading]);

  return (
    <>
      <Box position='relative'>
        {children}
        {isLoading && <LoadingOverlay rounded />}
      </Box>
      {type === 'default' ? <Divider /> : null}
      <CardActions sx={actionStyle}>{actions}</CardActions>
    </>
  );
};
